import script from "./RulesScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./RulesScreen.vue?vue&type=script&setup=true&lang=js"

import "./RulesScreen.vue?vue&type=style&index=0&id=4714b0ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4714b0ee"]])

export default __exports__